import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import clsx from 'clsx';
import { Button } from '@tribeplatform/react-ui-kit/Button';
/**
 * Square button that contains only an icon
 */
export const ComposerIconButton = forwardRef(({ icon: Icon, className, size = 'lg', ...props }, ref) => (_jsx(Button, { ref: ref, size: size, variant: "outline", leadingIcon: _jsx(Icon, {}, void 0), className: clsx('rounded-md', className), ...props }, void 0)));
//# sourceMappingURL=ComposerIconButton.js.map